import axios from 'axios';
import qs from 'query-string';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

const GuideApi = {
    getFirstAvailableArticle: strictQuery({
        In: z.string().array(),
        Out: z.string(),
        handler: (labels) =>
            axios.get('/articles/en-us/first-available', { params: { id: labels }, paramsSerializer: qs.stringify }),
    }),
};

export default GuideApi;
